import React from "react";
import { Link } from "react-router-dom";
import { 
  Box, Typography, Stack, IconButton, 
  Divider, Grid, alpha, useTheme 
} from "@mui/material";
import { ArrowForwardIos, AccessibilityNew } from "@mui/icons-material";

const BodyMapIssue = () => {
  const theme = useTheme();

  // আপনার অরিজিনাল ডাটা লিস্ট
  const bodyMapData = [
    { label: "Pressure Area/ Ulcer", count: 0 },
    { label: "Pain", count: 0 },
    { label: "Skin", count: 0 },
    { label: "Medication", count: 0 },
    { label: "Wound", count: 0 },
  ];

  return (
    <Box>
      {/* Header - Consistent with previous components */}
      <Box 
        sx={{ 
          p: 1.8, 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          bgcolor: alpha(theme.palette.primary.main, 0.03)
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <AccessibilityNew color="primary" sx={{ fontSize: 20 }} />
          <Typography 
            variant="subtitle1" 
            fontWeight={800} 
            sx={{ color: theme.palette.primary.main, fontSize: '0.95rem' }}
          >
            Body Map Issue
          </Typography>
        </Stack>
        
        <IconButton 
          component={Link} 
          to="/BodyMap"
          size="small"
          sx={{ 
            bgcolor: '#fff', 
            border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
            '&:hover': { bgcolor: theme.palette.primary.main, color: '#fff' }
          }}
        >
          <ArrowForwardIos sx={{ fontSize: 10 }} />
        </IconButton>
      </Box>

      <Divider />

      {/* Body - Clean list with counts */}
      <Box sx={{ p: 2 }}>
        <Stack spacing={1.5}>
          {bodyMapData.map((item, index) => (
            <Grid 
              container 
              key={index} 
              sx={{ 
                pb: 1, 
                borderBottom: index !== bodyMapData.length - 1 ? `1px dashed ${alpha(theme.palette.divider, 0.1)}` : 'none',
                alignItems: 'center'
              }}
            >
              <Grid item xs={10}>
                <Typography 
                  variant="body2" 
                  fontWeight={600} 
                  color="#475569" 
                  sx={{ fontSize: '0.85rem' }}
                >
                  {item.label}
                </Typography>
              </Grid>
              
              <Grid item xs={2} sx={{ textAlign: 'right' }}>
                <Typography 
                  variant="caption" 
                  fontWeight={900} 
                  sx={{ 
                    color: item.count > 0 ? 'error.main' : 'text.disabled',
                    bgcolor: item.count > 0 ? alpha(theme.palette.error.main, 0.1) : alpha(theme.palette.divider, 0.05),
                    px: 1.2, py: 0.4, borderRadius: '50%',
                    minWidth: '24px', display: 'inline-block', textAlign: 'center'
                  }}
                >
                  {item.count}
                </Typography>
              </Grid>
            </Grid>
          ))}
        </Stack>
      </Box>
    </Box>
  );
};

export default BodyMapIssue;